import { fmtUSD } from "@/lib/api";
import { Users, Wallet, TrendingDown, PiggyBank, FileWarning, ChevronRight } from "lucide-react";

export default function ResumenCoordinador({ resumen, vendedor, onSelect }) {
  if (!resumen) return null;
  const t = resumen.total;
  const porCoord = resumen.por_coordinador || [];
  const coordSelf = porCoord.length === 1 ? porCoord[0] : null;
  const faltantes = coordSelf ? (coordSelf.sin_informe || []) : [];

  return (
    <section
      data-testid="resumen-coordinador"
      className="rounded-xl overflow-hidden border border-emerald-800 shadow-sm"
    >
      {/* Total coordinador */}
      <div className="bg-emerald-900 text-white p-5 sm:p-6">
        <div className="flex items-center gap-2 text-emerald-200 text-xs font-semibold uppercase tracking-wide">
          <Users className="h-4 w-4" /> Resumen General del Coordinador
        </div>
        <div className="mt-3 grid grid-cols-2 lg:grid-cols-5 gap-3">
          <div>
            <div className="text-[10px] text-emerald-300 uppercase tracking-wide">Total Cartera</div>
            <div data-testid="resumen-total-cartera" className="font-bold text-base sm:text-lg whitespace-nowrap leading-tight">{fmtUSD(t.total_cartera)}</div>
          </div>
          <div>
            <div className="text-[10px] text-emerald-300 uppercase tracking-wide">Valor Vencido</div>
            <div className="font-bold text-sm sm:text-base text-red-300 whitespace-nowrap leading-tight">{fmtUSD(t.valor_vencido)}</div>
          </div>
          <div>
            <div className="text-[10px] text-emerald-300 uppercase tracking-wide">Cobrado del Mes</div>
            <div className="font-bold text-sm sm:text-base text-emerald-200 whitespace-nowrap leading-tight">{fmtUSD(t.cobrado_mes)}</div>
          </div>
          <div>
            <div className="text-[10px] text-emerald-300 uppercase tracking-wide">Vendedores</div>
            <div className="font-bold text-base" data-testid="resumen-vendedores-count">
              {coordSelf ? coordSelf.total_vendedores : resumen.por_vendedor.length}
            </div>
            {coordSelf && (
              <div className="text-[10px] text-emerald-300/90 leading-tight" data-testid="resumen-vendedores-coninforme">
                {coordSelf.con_informe} con informe
              </div>
            )}
          </div>
          <div>
            <div className="text-[10px] text-emerald-300 uppercase tracking-wide">Pagarés Pend.</div>
            <div className="font-bold text-base">{t.pagares_pendientes}</div>
          </div>
        </div>
      </div>

      {coordSelf && faltantes.length > 0 && (
        <div className="bg-amber-50 border-t border-amber-200 px-5 py-2.5 text-xs text-amber-800" data-testid="resumen-sin-informe">
          <span className="font-semibold">Sin informe cargado este período ({faltantes.length}):</span> {faltantes.join(", ")}
        </div>
      )}

      {/* Desglose individual por vendedor */}
      <div className="bg-white p-4 sm:p-5">
        <div className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-3">
          Detalle individual por vendedor · toque para filtrar el informe
        </div>
        <div className="overflow-x-auto rounded-lg border border-slate-100">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50 text-slate-500 text-[11px] uppercase tracking-wide">
                <th className="text-left px-3 py-2.5 font-semibold">Vendedor</th>
                <th className="text-center px-3 py-2.5 font-semibold">Clientes</th>
                <th className="text-right px-3 py-2.5 font-semibold">Total Cartera</th>
                <th className="text-right px-3 py-2.5 font-semibold">Vencido</th>
                <th className="text-right px-3 py-2.5 font-semibold">A Vencer</th>
                <th className="text-right px-3 py-2.5 font-semibold">Cobrado Mes</th>
                <th className="px-2"></th>
              </tr>
            </thead>
            <tbody>
              {resumen.por_vendedor.map((v) => {
                const active = vendedor === v.vendedor;
                return (
                  <tr
                    key={v.vendedor}
                    data-testid={`resumen-vendedor-${v.vendedor}`}
                    onClick={() => onSelect(active ? "__all__" : v.vendedor)}
                    className={`border-t border-slate-100 cursor-pointer transition-colors ${active ? "bg-emerald-50" : "hover:bg-emerald-50/50"}`}
                  >
                    <td className="px-3 py-2.5 font-semibold text-emerald-900 text-[13px] flex items-center gap-2">
                      <span className={`h-2 w-2 rounded-full shrink-0 ${active ? "bg-emerald-600" : "bg-slate-300"}`} />
                      <span className="truncate">{v.vendedor}</span>
                    </td>
                    <td className="px-3 py-2.5 text-center text-slate-600">{v.clientes}</td>
                    <td className="px-3 py-2.5 text-right font-semibold text-slate-900">{fmtUSD(v.total_cartera)}</td>
                    <td className="px-3 py-2.5 text-right text-red-600">{fmtUSD(v.valor_vencido)}</td>
                    <td className="px-3 py-2.5 text-right text-slate-600">{fmtUSD(v.valor_a_vencer)}</td>
                    <td className="px-3 py-2.5 text-right text-emerald-700">{fmtUSD(v.cobrado_mes)}</td>
                    <td className="px-2 text-slate-300"><ChevronRight className="h-4 w-4" /></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
